import React from 'react';
import Label from "components/general/Label"
//import 'styles/global.scss';
import {
  RESULT_STATUS,
  SCHEDULE_STATUS,
  getScheduleStatusAsInteger,
  getResultStatusAsInteger,
  scheduleIsRunningStatus,
  isLiveStatus
} from "helpers/status";

export const Status = React.memo((props) => {
  let { typeToPrint, scheduleStatus, resultStatus  } = props;
  const { className } = props;

  if (typeToPrint !== 'schedule') {
    typeToPrint = 'result'
  }

  scheduleStatus = isNaN(scheduleStatus) ? getScheduleStatusAsInteger(scheduleStatus) : scheduleStatus;
  resultStatus = isNaN(resultStatus) ? getResultStatusAsInteger(resultStatus) : resultStatus;

  if (scheduleStatus === SCHEDULE_STATUS.GETTING_READY || scheduleStatus === SCHEDULE_STATUS.SCHEDULED_BREAK) {
    scheduleStatus = SCHEDULE_STATUS.RUNNING
  }

  if (typeToPrint === 'result' 
    && (resultStatus === RESULT_STATUS.OFFICIAL || resultStatus === RESULT_STATUS.PROTESTED || scheduleStatus === 0)) {
    typeToPrint = 'result'
  } else {
    typeToPrint = 'schedule'
  }

  let printStatus = '';
  let classStatus = '';
  
  if (scheduleStatus > SCHEDULE_STATUS.SCHEDULED) {
    if (typeToPrint === 'schedule') {
      printStatus = 'status_' + scheduleStatus
    } else {
      printStatus = 'resultStatus_' + resultStatus
    }
  } else if (scheduleStatus === 0){  // to avoid void status in subunits not scheduled
    printStatus = 'resultStatus_' + resultStatus
  }


  if (isLiveStatus(resultStatus) || scheduleIsRunningStatus(scheduleStatus)) {
    classStatus = 'currentIndicator'
  }

  return (
    <div className={`${className} d-inline px-3 fw-bold ${printStatus ? classStatus : ''}`}>
      <Label data={printStatus} />
    </div>
  )
});

export default Status